import { MULTI_ORDER_VALUE } from 'my-purchases/constants/constants'
import { ORDER_TYPES } from 'my-purchases/constants/orderTypes'
import type { PriceToFormatProps } from 'my-purchases/hooks/useFormatPrice/useFormatPrice'
import type { FormattedPrices } from 'my-purchases/types/purchaseCommon'
import type {
	NonNormalizedPurchaseDetails,
	PurchaseDetails,
} from 'my-purchases/types/purchaseDetail'

export const normalizeData = ({
	formatPrice,
	purchase,
}: {
	formatPrice: (props: PriceToFormatProps) => FormattedPrices
	purchase: NonNormalizedPurchaseDetails
}) => {
	const {
		totalPriceCurrency: currency,
		totalPriceAmount,
		totalPrice,
		taxAmount,
		tax,
		subTotalAmount,
		subTotal,
		shippingPriceAmount,
		shippingPrice,
		orders,
		type,
		// Online purchase only
		paidAmountValue,
		paidAmount,
		paidBalanceAmountValue,
		paidBalanceAmount,
	} = purchase

	return {
		...purchase,
		totalPriceAmountConverted: formatPrice({
			rawPrice: totalPriceAmount,
			formattedPrice: totalPrice,
			purchaseCurrency: currency,
		}),

		taxAmountConverted: formatPrice({
			rawPrice: taxAmount,
			formattedPrice: tax,
			purchaseCurrency: currency,
		}),
		subTotalAmountConverted: formatPrice({
			rawPrice: subTotalAmount,
			formattedPrice: subTotal,
			purchaseCurrency: currency,
		}),
		shippingPriceAmountConverted: formatPrice({
			rawPrice: shippingPriceAmount,
			formattedPrice: shippingPrice,
			purchaseCurrency: currency,
		}),
		...(type === ORDER_TYPES.ONLINE && {
			paidAmountValueConverted: formatPrice({
				rawPrice: paidAmountValue ?? null,
				formattedPrice: paidAmount ?? '',
				purchaseCurrency: currency,
			}),
			paidBalanceAmountValueConverted: formatPrice({
				rawPrice: paidBalanceAmountValue ?? null,
				formattedPrice: paidBalanceAmount ?? '',
				purchaseCurrency: currency,
			}),
		}),
		orders: orders.map((order) => {
			const lines = order.lines.map((line) => ({
				...line,
				originalPriceAmountConverted: formatPrice({
					rawPrice: line.originalPriceAmount,
					formattedPrice: line.originalPrice,
					purchaseCurrency: currency,
				}),
				paidPriceAmountConverted: formatPrice({
					rawPrice: line.paidPriceAmount,
					formattedPrice: line.paidPrice,
					purchaseCurrency: currency,
				}),
			}))
			return {
				...order,
				lines,
				firstLineArticleImageId: order.lines[0].id,
				firstlineArticleColorId: order.lines[0].colorId,
				subTotalConverted: formatPrice({
					rawPrice: order.subTotalAmount,
					formattedPrice: order.subTotal,
					purchaseCurrency: currency,
				}),
			}
		}),
		isMulti: orders && orders.length >= MULTI_ORDER_VALUE,
	} as PurchaseDetails
}
